// extracted by mini-css-extract-plugin
module.exports =  {"root":"WyiYv3LRC6pJjxxoM7u8","brand":"fI1vmXetZJvzif5kGNgt","section":"yCV_XNmicOv3tHWMu_nq"};